import './_style.css'
import {useContext, useEffect, useRef, useState} from "react";
import AuthContext from "../../context/AuthContext";
import {NavLink, useParams} from "react-router-dom";
import * as React from "react";
import BreadCrumbs from "../../components/BreadCrumbs";


function UsageGridHeader() {

    return (
        <div className="grid-base grid-header field-srcusage-grid-columns">
            <div>#</div>
            <div>Trg Field ID</div>
            <div>Target Field Type</div>
            <div>Target Field Name</div>
            <div>Mapping</div>
        </div>
    )
}

function UsageGridRow(props: any) {

    const {num, dataObj} = props

    // 'function FuncName()' is a React Component and NOT a classic JS function,
    // the below is the JS function inside the React:
    const nameReducer = (f_str: any, max_len: number) => {
        if (f_str && f_str.length > max_len) {
            f_str = f_str.slice(0, max_len) + '...'
        }
        return f_str
    }
    // example of the 'srcObj': {'srcFieldID': 'monitor', 'srcFieldName': 'monitor', 'srcFieldUID': 'b24a0a693f3145c4', 'srcFieldType': 'category'},

    // let trgFieldID = nameReducer(dataObj.trgFeatID, 24)
    // let trgFieldName = nameReducer(dataObj.trgCatName, 28)

    let mappingURL = `../map/${dataObj.trgFieldUID}/`

    return (
        <div className="grid-base grid-row field-srcusage-grid-columns">
            <div>{num}</div>
            <div>{dataObj.trgFieldID}</div>
            <div>{dataObj.trgFieldType}</div>
            <div>{dataObj.trgFieldName}</div>
            <div className="grid-row-itemlink">
                <NavLink to={mappingURL}>click here</NavLink>
            </div>
        </div>
    )
}


export default function FieldsListSrcUsage() {
    let {user, logoutUser, authTokens, serverIP} = useContext(AuthContext)

    const {prjid, field_pk} = useParams()

    const crumbItems = [
        {'name': 'Main', 'link': '/'},
        {'name': 'Mapper Projects', 'link': '../../../projects/1'},
        {'name': 'Fields List', 'link': '../1'},
        {'name': 'Source field usage', 'link': ''}
    ]

    const srcObjRef = useRef({
        srcFieldUID: '',
        srcFieldID: '',
        srcFieldType: '',
        srcFieldName: ''})
    let srcObj = srcObjRef.current

    const [trgDataList, setTrgDataList] = useState([])

    useEffect(() => {
        getUsageData()
    }, [])

    let getUsageData = async () => {
        let response = await fetch(`${serverIP}/getsrcfieldusage/`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + String(authTokens.access)
            },
            body: JSON.stringify([prjid, field_pk]),
        })
        let data = await response.json()

        if (response.status === 200) {
            setTrgDataList(data.trgData)

            srcObjRef.current = data.srcObj

        } else if (response.statusText === 'Unauthorized') {
            logoutUser()
        }
    }

    const gridRowElements = trgDataList.map((item, index) => {
        return <UsageGridRow
            key={index}
            num={index + 1}
            dataObj={item}
        />
    })

    return (
        <>
            <BreadCrumbs user={user} itemsLinks={crumbItems}/>

            <div style={{margin: '20px 10px', fontSize: '0.85rem'}}>
                {trgDataList?.length > 0 ?
                    <span> The source field <b>{srcObj.srcFieldName}</b> (ID: {srcObj.srcFieldID}) is used in {trgDataList?.length} target mappings:
                </span>
                    :
                    <span>The field <b>{srcObj.srcFieldName}</b> (ID: {srcObj.srcFieldID}) do not take part in any mappings yet.</span>
                }</div>

            <UsageGridHeader/>

            <div className="grid-rows-container">{gridRowElements}</div>
        </>
    )
}